import { render, staticRenderFns } from "./DocumentGroupHeader.vue?vue&type=template&id=d0319422&scoped=true&"
import script from "./DocumentGroupHeader.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0319422",
  null
  
)

export default component.exports